import { defineStore } from 'pinia'

export const useMenuStore = defineStore('menu', {
    state: () => {
        return { menu: null }
    },
    // could also be defined as
    // state: () => ({ count: 0 })
    actions: {
        change() {
            console.log(this.menu, "MENU")
            this.menu = !this.menu;
            console.log(this.menu, "MENU")
        },
    },
})
